import { Component, OnInit } from '@angular/core';
import {
  AFetchRemotes,
  AFetchResorts,
  ALogin,
  ALoginDesktop,
  ASetRemote,
  ASetResort,
  PlaylistRemoteAppState,
  sseApi,
  xhrApi
} from '../../../store';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgRedux, Select } from '@angular-redux3/store';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { DesktopService } from '../../../services/desktop.service';
import { Remote } from '../../../store/entities';

@Component({
  selector: 'mwo-login-desktop',
  templateUrl: './login-desktop.component.html',
  styleUrls: ['./login-desktop.component.scss']
})
export class LoginDesktopComponent implements OnInit {

  handleTechStatusTimeout = 1000;

  currentApplicationVersion = environment.appVersion;
  @Select(['user', 'loggedIn']) isLoggedIn$: Observable<boolean>;
  public backgroundImage: string | undefined;
  private readonly imageNames: string[] = [
    'login-bg-1.webp',
    'login-bg-2.webp',
    'login-bg-3.webp',
    'login-bg-4.webp',
    'login-bg-5.webp'
  ];
  loginForm = new FormGroup({
    playerBid: new FormControl('', [
      Validators.required,
      Validators.minLength(1)
    ])
  });
  syncMode = false;
  currentValue: number;
  maxValue: number;
  syncMessage: string;
  syncError: string;
  httpError: string;
  bidPending = false;
  private waitStatus = false;
  private bidError: string;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private router: Router,
    private desktopService: DesktopService) {
  }

  ngOnInit(): void {
    // this.ngRedux.dispatch({type: TUser.LOGIN, payload : {email : 'desktop', password: 'desktop', rememberMe: true}});
    this.handleTechStatus();
    this.backgroundImage = this.getRandomImagePath();
    localStorage.setItem('bgUrl', this.backgroundImage);

    this.isLoggedIn$.pipe(filter(Boolean)).subscribe(() => {
        this.handleTechStatus();
        // this.router.navigate(['/library']);
      }
    );
  }

  getRandomImagePath(): string {
    const randomIndex = Math.floor(Math.random() * this.imageNames.length);
    return `assets/login-bg/${this.imageNames[randomIndex]}`;
  }

  private handleTechStatus() {
    this.desktopService.getTechnicalInfo().subscribe((technical) => {
      if (technical) {
        const { bidStatus, syncStatus, downloadStatus } = technical.datas;
        this.handleBidStatus(bidStatus, syncStatus, downloadStatus);
      }
    }, (error) => {
      this.syncError = 'Is the player running ?';
      this.httpError = error.message;
      this.restartStatus();
    });
  }

  private handleBidStatus(bidStatus, syncStatus, downloadStatus) {
    switch (bidStatus.type) {
      case 'NOT_SET':
        this.bidPending = false; // visiblement il passe à true trop top
        this.syncError = '';
        this.bidError = '';
        this.syncMode = false;
        this.restartStatus();
        break;
      case 'OK':
        this.syncError = '';
        this.bidPending = false;
        if (!syncStatus?.type && !downloadStatus?.type) {
          this.restartStatus();
          break;
        }
        if (syncStatus?.type) {
          this.handleSyncStatus(syncStatus);
        }
        if (downloadStatus?.type) {
          this.handleDownloadStatus(downloadStatus);
        }
        break;
      case 'PENDING':
        this.bidPending = true;
        this.syncError = '';
        this.bidError = '';
        this.restartStatus();
        break;
      case 'ERROR':
        this.bidError = bidStatus.message;
        this.bidPending = false;
        this.syncError = '';
        this.restartStatus();
        break;
      default:
        console.warn('bidStatus not implemented', bidStatus);
        this.restartStatus();
        break;
    }
  }

  private restartStatus() {
    if (this.waitStatus) {
      return;
    }
    this.waitStatus = true;
    setTimeout(() => {
      this.waitStatus = false;
      this.handleTechStatus();
    }, this.handleTechStatusTimeout);
  }

  private handleSyncStatus(syncStatus) {
    switch (syncStatus.type) {
      case 'STARTING':
        this.syncMessage = 'Starting sync 🚀';
        this.syncMode = true;
        this.restartStatus();
        break;
      case 'SYNCING':
        this.syncMode = true;
        this.syncMessage = 'Loading data ⏰: '
          + syncStatus.message + '(total : ' + syncStatus.currentValue + '/' + syncStatus.maxValue + ')';
        this.restartStatus();
        break;
      case 'ERROR':
        this.syncError = '🔴 ' + syncStatus.message;
        this.restartStatus();
        break;
      case 'OFFLINE':
      case 'FINISHED':
      default:
        this.syncError = '';
    }
  }

  private handleDownloadStatus(downloadStatus) {
    switch (downloadStatus.type) {
      case 'FINISHED':
        this.syncMode = false;
        this.desktopService.getPlayerInfo().subscribe((playerInfo) => {
          if (playerInfo) {
            this.loadLibrary(playerInfo);
          }
        });
        break;
      default:
        this.syncMode = true;
        this.currentValue = downloadStatus.currentValue;
        this.maxValue = downloadStatus.maxValue;
        this.syncMessage = '🤩 ' + downloadStatus.message;
        this.restartStatus();
        break;
    }
  }

  private loadLibrary(playerInfo) {
    const playerId = playerInfo.datas.player.id;
    this.ngRedux.dispatch(ALogin({ email: 'desktop', password: 'desktop', rememberMe: true }));
    xhrApi.setPlayerId(playerId);
    sseApi.startStatus('/sse-status/' + playerId + '?ngsw-bypass=true');
    this.ngRedux.dispatch(AFetchResorts());
    this.ngRedux.select<Array<{ id: string; name: string }>>('resorts').subscribe(resorts => {
      if (resorts.length >= 1) {
        this.ngRedux.dispatch(ASetResort(resorts[0]));
        this.ngRedux.dispatch(AFetchRemotes(resorts[0].id));
        this.ngRedux.select<Array<{ id: string; name: string }>>('remotes').subscribe(remotes => {
          if (remotes.length >= 1) {
            this.ngRedux.dispatch(ASetRemote(remotes[0]));
            this.ngRedux.select<Remote>('remote').pipe(
              filter(remote => remote && remote.id === remotes[0].id),
              tap(() => this.router.navigate(['/library'])),
            ).subscribe();
          }
        });
      }
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const { playerBid } = this.loginForm.controls;
      const payload = {
        bid: playerBid.value
      };
      this.bidPending = true;
      this.ngRedux.dispatch(ALoginDesktop(payload));
    }
  }
}
